<template>
  <footer>
    <div
      class="flex flex-col bg-[#232323] w-full items-center pt-[72px] pr-[54px] pb-[41px] pl-[46px] lg:bg-[--black] lg:px-[102px] lg:py-[70.5px]">
      <div class="flex flex-col gap-[23px] xl:w-[1280px]">
        <div class="flex flex-col gap-[23px] items-center lg:flex-row lg:justify-between lg:items-start">
          <div class="flex flex-col gap-[23px] items-center lg:items-start lg:max-w-[380px] xl:shrink-0">
            <a href="#" title="Vip Financeira" rel="follow">
              <img width="124" src="/img/logos/vip.svg" alt="Vip Financeira" />
            </a>
            <p class="mt-[4px] text-white body-text-3 lg:text-left leading-[140%]">
              Desde 2008 atuando no mercado de consignado, essa é uma garantia
              de que todo o processo terá credibilidade, segurança, qualidade e
              excelência.
            </p>
            <div class="flex flex-col gap-[3px] items-center">
              <p class="text-white font-semibold leading-[140%] text-[15px]">
                SIGA-NOS
              </p>
              <ul class="flex items-center gap-[13px]">
                <li v-for="(link, index) in socialLinks" :key="index">
                  <a :href="link.href" rel="nofollow" :title="link.title" target="_blank">
                    <img :width="link.width" :src="link.icon" :alt="link.alt" />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="flex flex-col w-full items-center gap-[14px] white lg:flex-row lg:w-auto lg:items-start lg:gap-[20px] xl:mr-[20px] xl:gap-[14px]">
            <div v-for="(section, index) in links" :key="index"
              class="flex flex-col gap-[10px] items-center lg:items-start" :class="[
                index === links.length - 1 ? 'lg:w-auto' : 'xl:w-[231px]',
              ]">
              <h3 class="footer-menu-header">{{ section.title }}</h3>
              <ul class="flex flex-col gap-[10px] items-center lg:items-start">
                <li v-for="(item, i) in section.items" :key="i" class="footer-menu-item">
                  <a :href="item.href" :rel="item.external ? 'follow' : null" :target="item.external ? '_blank' : null"
                    :title="item.label">
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr class="border-t border-[--white] opacity-[16%] mt-[23px] mb-[11px]" />

        <div class="">
          <div class="flex flex-col gap-[8px] lg:flex-row lg:justify-between lg:items-center">
            <p class="white text-center">
              2026 © Todos os direitos reservados. Vip Promotora de Crédito
            </p>
            <div class="flex justify-between">
              <a href="/politica.html" class="footer-link lg:w-[197px] hover:text-[#FCB813] transition-all ease-linear"
                rel="nofollow" target="_blank">
                Políticas de Privacidade
              </a>
              <a href="/pcookie.html" class="footer-link lg:w-[184px] hover:text-[#FCB813] transition-all ease-linear"
                rel="nofollow" target="_blank">
                Termo de Uso
              </a>
            </div>
          </div>
          <div class="mt-[50px] body-text-3 text-[#929292] leading-[124%] !text-justify w-full">
            <i class="not-italic">
              A Vip Promotora atua na oferta de crédito, incluindo a antecipação do FGTS. Este serviço é um empréstimo e possui taxas de juros aplicáveis que impactam o saldo do seu fundo. Não há garantia de aprovação imediata. Oferta válida apenas para maiores de 18 anos. Leia nossos termos e condições.
              <br/>
              <br/>
              <strong>ATENÇÃO: </strong>A antecipação do FGTS é uma operação de crédito sujeita a encargos financeiros. Incidem juros e
              IOF (Imposto sobre Operações Financeiras) sobre o valor contratado. O prazo máximo para pagamento é de até
              5 anos (60 meses), com parcelas descontadas automaticamente da conta de FGTS do cliente no mês do
              aniversário, a cada ano. O Custo Efetivo Total (CET) é informado antes da contratação. A aprovação está
              condicionada à análise de crédito da instituição financeira parceira.
              <br/>
              <br/>
              A Vip Promotora não é uma instituição financeira e não realiza
              operações de crédito diretamente. A Vip Promotora é uma plataforma
              digital que atua como correspondente bancário para facilitar o
              processo de contratação de produtos financeiros. Como
              correspondente bancário, seguimos as diretrizes do Banco Central
              do Brasil, nos termos da Resolução nº. 3.954, de 24 de fevereiro
              de 2011. Toda avaliação de crédito será realizada conforme a
              política de crédito da Instituição Financeira escolhida pelo
              usuário. Antes da contratação de qualquer serviço através de
              nossos parceiros, você receberá todas as condições e informações
              relativas ao produto a ser contrato, de forma completa e
              transparente. VIP SOLUÇÕES LTDA - CNPJ 56.950.767/0001-36 |
              Endereço: Rua Castro Alves, 176 - Andar 1 - 88101-160 - Campinas,
              São José - SC.</i>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TFooter",
  props: {
    originTag: String,
  },
  data() {
    return {
      links: [
        {
          title: "INSTITUCIONAL",
          items: [
            { label: "Home", href: "/" },
            { label: "Sobre nós", href: "#sobre" },
            { label: "Serviços", href: "#servicos" },
            { label: "Depoimentos", href: "#depoimentos" },
            { label: "FAQ", href: "faq" },
            {
              label: "Trabalhe Conosco",
              href: "https://api.whatsapp.com/send?phone=554899440887&text=Desejo+enviar+meu+currículo",
              external: true,
            },
          ],
        },
        {
          title: "SOLUÇÕES",
          items: [
            {
              label: "Crédito Consignado",
              href: "https://consignado.vipfinanceira.com.br/",
              external: true,
            },
            {
              label: "Antecipação de FGTS",
              href: "https://fgts.vipfinanceira.com.br/",
              external: true,
            },
          ],
        },
        {
          title: "CONTATOS",
          items: [
            {
              label: "sac@vipfinanceira.com.br",
              href: "mailto:sac@vipfinanceira.com.br",
              external: true,
            },
            {
              label: "(48) 3199-7783",
              href: "tel:+554831997783",
              external: true,
            },
          ],
        },
      ],

      socialLinks: [
        {
          title: "Siga-nos no Facebook",
          href: "https://www.facebook.com/vippromotoraoficial",
          icon: "/img/logos/facebook.svg",
          width: 12,
          alt: "Vip Financeira facebook",
        },
        {
          title: "Siga-nos no Linkedin",
          href: "https://www.linkedin.com/company/vip-promotora-de-cr%C3%A9dito/",
          icon: "/img/logos/linkedin.svg",
          width: 16,
          alt: "Vip Financeira linkedin",
        },
        {
          title: "Siga-nos no Instagram",
          href: "https://www.instagram.com/vip.promotora/",
          icon: "/img/logos/instagram.svg",
          width: 24,
          alt: "Vip Financeira instagram",
        },
      ],
    };
  },
};
</script>
